/* eslint-disable no-param-reassign */

import '../frontend/styles/frontend-styles.scss';

window.addEventListener('DOMContentLoaded', () => {
  const tableOfContents = document.querySelector('.bbTOC-tableOfContents');

  if (tableOfContents) {
    /**
     * Get our selected heading levels and build our query string we will use to query the DOM.
     *
     * Will end up something like 'h2,h3,h4'
     */
    const queryString = selectedHeadingLevels // eslint-disable-line no-undef
      .join()
      .split(',')
      .map((i) => `h${i}`)
      .join(',');

    // Find the headings of that have the selected level.
    const targetHeadings = [...document.querySelectorAll(`${queryString}`)].filter(
      (heading) => heading.id !== '' && !heading.hasAttribute('data-hide-from-TOC'),
    );

    // Find the headings in our table of contents.
    const tocHeadings = [...document.querySelectorAll('.bbTOC-tableOfContents li p a')];

    /**
     * Assign the href attribute of each heading the table. Uses its index in the whole page as an
     * identifier so that it shouldn't matter if you have the same heading text in multiple places.
     */
    tocHeadings.forEach((heading, index) => {
      heading.href = `#${targetHeadings[index].id}`;
    });
  }
});
